import { cn } from "@/lib";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
      data-oid="ml_7z0c"
    />
  );
}

export { Skeleton };
